/**
 * UnknownDeviceError
 * Thrown when we get UNKNOWN_DEVICE from appserver.
 */
export default class UnknownDeviceError extends Error {
  
  // TODO: this is duck-typing, because babel is broken
  static type = "UnknownDeviceError";
  
  static responseCode = "UNKNOWN_DEVICE";
  
  constructor(response) {
    super("This device was not recognised by appserver.");
    this.response = response;
    this.type = UnknownDeviceError.type;
  }
  
}



// WEBPACK FOOTER //
// ./src/lib/appserver/responseExceptions/UnknownDeviceError.js